import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";

import { MaterialCard } from "@learningblocks/simulations/shared-components";
import { getImageData } from "./component_data";

import style from "./style.module.scss";

class MaterialSectionBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      materials: [],
    };
  }

  buildComponent = (data, index) => {
    let carddata = {
      key: index + "_" + data.props.type + "_" + data.component,
      id: data.props.id,
      fullName: data.props.fullName,
      description: data.props.description,
      ariaLabel: data.props.hasOwnProperty("ariaLabel")
        ? data.props.ariaLabel
        : "",
      isSolutionTube: data.props.hasOwnProperty("solutionTube") ? true : false,
      solutionTube: data.props.hasOwnProperty("solutionTube")
        ? data.props.solutionTube
        : {},
      contentID: "",
      image: data.props.hasOwnProperty("solutionTube")
        ? null
        : getImageData(data.component, data.props),
    };
    return <MaterialCard {...carddata} />;
  };

  componentDidMount() {
    this.doCompPart(this.props.materials, this.props.groups);
  }

  doCompPart = (data, groups) => {
    let groupArr = [];

    Object.keys(groups).forEach((key, index) => {
      let compArr = [];
      groups[key].components.forEach((component) => {
        if (data.hasOwnProperty(component)) {
          if (component == "CellSpreader") {
            compArr.push(this.buildComponent(data[component].components[0], 0));
          } else {
            data[component].components.forEach((comp, index) => {
              if (comp["component"] == "Solution") {
                if (!groups[key].hasOwnProperty("type")) {
                  compArr.push(this.buildComponent(comp, index));
                } else if (
                  groups[key]["type"] == "Filled" &&
                  comp["props"]["volume"] > 0
                ) {
                  compArr.push(this.buildComponent(comp, index));
                } else if (
                  groups[key]["type"] == "Empty" &&
                  comp["props"]["volume"] == 0
                ) {
                  compArr.push(this.buildComponent(comp, index));
                }
              } else if (comp["component"] == "CellSpreader") {
              } else {
                compArr.push(this.buildComponent(comp, index));
              }
            });
          }
        }
      });

      if (typeof compArr[0] != "undefined") {
        groupArr.push(
          <div aria-label={key} key={index} className={style.Category}>
            <h3 tabIndex={0} aria-label={key} className={style.CategoryHeading}>
              <FormattedMessage id={key} defaultMessage={key} />
              {}
            </h3>
            <h6 className={style.CategoryDescription} tabIndex={0}>
              {groups[key].description &&
                this.props.intl.formatMessage({
                  id: groups[key].description,
                  defaultMessage: groups[key].description,
                })}
            </h6>
            <div aria-label={key} className={style.Group}>
              {compArr}
            </div>
          </div>
        );
      }
    });

    this.setState({
      materials: groupArr,
    });
  };

  render() {
    return (
        <div className={style.Materials} dir="auto">
          <p className={style.HelperText}>{
            this.props.intl.formatMessage({
              id: this.props.helperText,
              defaultMessage: this.props.helperText,
            })}
          </p>
          {this.state.materials}
        </div>
    );
  }
}

MaterialSectionBase.propTypes = {
  materials: PropTypes.object.isRequired,
  helperText: PropTypes.string,
  groups: PropTypes.object.isRequired,
};

export const MaterialSection = injectIntl(MaterialSectionBase);
